// name:util
import axios from 'axios'
class Base {
    constructor() {
        //默认执行
    }

    /**
     * 在 Safari 和 IE8上执行 new Date() 会得到 Invalid Date
     * 重写默认的 Date 函数，以解决以上 bug
     * 原型添加 $format 方法
     * new Date().$format('yyyy-MM-dd hh:mm:ss')
     * new Date().$format('yyyy-MM-dd hh:mm')
     * new Date().$format('yyyy-MM-dd hh:mm:ss.S')
     */
    reConstructorDate() {
        // eslint-disable-next-line wrap-iife, no-native-reassign
        return function(Date) {
            myDate.now = Date.now
            myDate.parse = Date.parse
            myDate.prototype = Date.prototype
            myDate.prototype.$format = function(date) {
                const obj = {
                    'M+': this.getMonth() + 1,
                    'd+': this.getDate(),
                    'h+': this.getHours(),
                    'm+': this.getMinutes(),
                    's+': this.getSeconds(),
                    'S': this.getMilliseconds()
                }
                if (/(y+)/.test(date)) {
                    date = date.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let key in obj) {
                    if (new RegExp('(' + key + ')').test(date)) {
                        date = date.replace(RegExp.$1, (RegExp.$1.length == 1) ? (obj[key]) : (('00' + obj[key]).substr(('' + obj[key]).length)))
                    }
                }
                return date
            }
            return myDate
            function myDate() {
                // 当只有一个参数并且参数类型是字符串时，把字符串中的-替换为/
                if (arguments.length === 1) {
                    let arg = arguments[0]
                    if (Object.prototype.toString.call(arg) === '[object String]' && arg.indexOf('T') === -1) {
                        arguments[0] = arg.replace(/-/g, '/')
                    }
                }
                let bind = Function.bind
                let unbind = bind.bind(bind)
                // eslint-disable-next-line new-parens
                return new (unbind(Date, null).apply(null, arguments))
            }
        }(Date)
    }

    // 去抖
    debounce(func, wait, immediate) {
        let timeout, args, context, timestamp, result
        const later = function() {
            // 据上一次触发时间间隔
            const last = +new Date() - timestamp
            // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
            if (last < wait && last > 0) {
                timeout = setTimeout(later, wait - last)
            } else {
                timeout = null
                // 如果设定为immediate === true，因为开始边界已经调用过了此处无需调用
                if (!immediate) {
                    result = func.apply(context, args)
                    if (!timeout) context = args = null
                }
            }
        }

        return function(...args) {
            context = this
            timestamp = +new Date()
            const callNow = immediate && !timeout
            // 如果延时不存在，重新设定延时
            if (!timeout) timeout = setTimeout(later, wait)
            if (callNow) {
                result = func.apply(context, args)
                context = args = null
            }
            return result
        }
    }

    // 数据格式化
    // 评论数、关注数等
    dataFormat(el) {
        const num = el + '';
        const len = num.length;
        if (len > 8) {
            return `${ num.slice(0, -8) }.${ num.slice(-8, -6) }亿`;
        } else if (len > 5) {
            return `${ num.slice(0, -4) }万`;
        } else {
            return num;
        }
    }

    // money格式化
    // 转化为以分为单位的整型
    moneyFormat(val) {
        const str = val + '';
        if (str.indexOf('.') === -1) {
            return val * 100
        } else {
            const ary = str.split('.');
            return (ary[0] * 100) + (ary[1].substring(0, 2) * 1)
        }
    }

    // 添加cookie
    setCookie(key, val, days) {
        const Days = days || 1;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = `${ key }=${ encodeURIComponent(val) };path=/;expires=${ exp.toGMTString() }`;
    }

    // 获取cookie
    getCookie(key) {
        let arr, reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return decodeURIComponent(arr[2]);
        } else {
            return null;
        }
    }

    // 删除cookie
    delCookie(key) {
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let val = this.getCookie(key);
        document.cookie = `${ key }=${ encodeURIComponent(val) };path=/;expires=${ exp.toGMTString() }`;
    }

    // 返回 query string（encodeURIComponent(k)=encodeURIComponent(v)&encodeURIComponent(k)=encodeURIComponent(v)...）
    queryFormat(params) {
        let flag = true;
        let string = '';
        for (const key in params) {
            string += flag ? '?' : '&';
            string += key + '=' + params[key];
            if (flag) {
                flag = false;
            }
        }
        return string;
    }

    // 根据 key 返回 query string 的 val
    getUrlParam(key) {
        var str = window.location.search;
        if (str.indexOf(key) !== -1) {
            const pos1 = str.indexOf(key) + key.length + 1;
            const pos2 = str.indexOf("&", pos1);
            let val = pos2 == -1 ? str.substring(pos1) : str.substring(pos1, pos2);
            try {
                return decodeURIComponent(val)
            } catch(e) {
                const len = val.length - 1;
                if (val.substring(len) == '%') {
                    return decodeURIComponent(val.substring(0, len)) + '%'
                }
            }
        }
    }

    // 把list转换为指定key值的obj
    // [{ id: 1, label: '1' }] => { 1: {id: 1, label: '1'} }
    transListToObj(list, key) {
        let obj = {};
        list.forEach(item => {
            obj[item[key]] = item;
        })
        return obj;
    }

    // 段落文字格式化
    // notrim: Bolean 为true时：不去除左右空格、回车
    formatArticle(str, notrim) {
        String.prototype.replaceAll  = function(s1, s2) {
            return this.replace(new RegExp(s1, "gm"), s2);
        }
        let ans = str;
        if (!notrim) {
            ans = ans.replace(/(^\s*)/g, "");   //去除左边空格+回车
            ans = ans.replace(/(\s*$)/g, "");   //去除右边空格+回车
        }
        ans = ans.replaceAll('\n', '<br/>');     //替换回车
        // ans = ans.replaceAll(' ', '&nbsp;');     //替换空格（20220811:因文本中可能含有a标签,<a&nbsp;href>无法被解析，故注释此处）
        return ans;
    }

    //返回文件名或后缀
    getFileName(path, mode) {
        if (path) {
            const pos1 = path.lastIndexOf('/');
            const pos2 = path.lastIndexOf('\\');
            const pos = Math.max(pos1, pos2);
            switch (mode) {
                case 'name':
                    return path.substring(pos + 1).replace(/\..+/,""); // 获取不带后缀文件名
                break;
                case 'suffix':
                    return path.replace(/.+\./,""); // 获取后缀
                break;
                default:
                    return path.substring(pos + 1); // 获取带后缀文件名
                break;
            }
        }
    }

    // 个位数字加0；
    changeNumber(el) {
        return el < 10 ? `0${ el }` : el;
    }

    // 返回n位的随机字符串
    returnRandomStr(n) {
        var i, str = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
        for(i = 0; i < n; i++){
            str += chars.charAt(Math.floor(Math.random() * 62));
        }
        return str;
    }

    // 验证图片格式
    testPic(val) {
        return /jpg|jpeg|png|webp|JPG|JPEG|PNG|WEBP/.test(val);
    }

    // 验证图片格式
    testVideo(val) {
        return /WMV|MPEG|MPG|MPE|MOV|3GP|MP4|M4V|AVI|FLV/.test(val);
    }

    // 返回在table列表显示的时间格式
    // html格式 必须使用v-html展示
    returnTableTime(val) {
        if (val) {
            let timeStr = typeof val === 'number' ? new Date(val).$format('yyyy-MM-dd hh:mm:ss') : val;
            return timeStr.replace(' ', '<br/>');
        } else {
            return '-';
        }
    }

    // 返回对应的date
    // returnDate('05:50') => Thu May 03 2018 05:50:00 GMT+0800 (CST) 当日时间
    returnDate(val) {
        let date = new Date();
        let time = [0, 0, 0, 0];
        if (val.indexOf(' ') !== -1 || val.indexOf(':') !== -1) {
            val.split(':').map((item, index) => {
                time[index] = item;
            });
        }
        date.setHours(time[0]);
        date.setMinutes(time[1]);
        date.setSeconds(time[2]);
        date.setMilliseconds(time[3]);
        return date;
    }

    // 返回限制指定位数的数字
    // returnFloat({
    //     val: x.xxxx,
    //     tens: 2,
    //     callback: (() => {})
    // }) => callback(x.xx)
    returnFloat(options) {
        return new Promise(resolve => {
            if (options.val) {
                const val = options.val + '';
                const ary = val.split('.');
                if (ary.length > 1 && ary[1].length > options.tens) {
                    const num = Math.pow(10, options.tens);
                    resolve(Math.floor(val * num) / num);
                }
            }
        })
    }

    //时间格式转换为时间戳
    //'2006-03-05 12:00:00'                     => 1141531200000
    //'Sun Mar 05 2006 12:00:00 GMT+0800 (CST)' => 1141531200000
    timeToTimestamp(params) {
        return params ? Date.parse(params) || Date.parse(params.replace(/-/g, "/")) : '';
    }

    // 返回n小时前xx:xx:xx - 当前xx:xx:xx => time格式
    returnHoursBefore(n) {
        let startTime = new Date();
        startTime.setTime(startTime.getTime() - 3600 * 1000 * n);
        let endTime = new Date();
        return [startTime, endTime];
    }

    // 返回n天前的00:00:00 - 今天的23:59:59 => time格式
    returnDaysBefore(n) {
        let startTime = new Date();
        startTime.setHours(0);
        startTime.setMinutes(0);
        startTime.setSeconds(0);
        startTime.setMilliseconds(0);
        startTime.setDate(startTime.getDate() - n);
        let endTime = new Date();
        endTime.setHours(23);
        endTime.setMinutes(59);
        endTime.setSeconds(59);
        endTime.setMilliseconds(999);
        return [startTime, endTime]
    }

    // 返回最近n个月的time格式数组 => 目标月1号00:00:00 - 本月最后一天23:59:59
    returnMonthsBefore(n) {
        if (typeof n !== 'number' || n < 0) {
            return [];
        }
        let startTime = new Date();
        let mon = startTime.getMonth();
        if (mon < n) {
            const yearNum = Math.floor(n / 12); // 考虑 n 跨年的部分
            const nMod = n % 12; // n 与 12 取余
            const year = startTime.getFullYear();
            startTime.setMonth(12 - nMod + mon);
            startTime.setFullYear(year - yearNum - 1);
        } else {
            startTime.setMonth(mon - n);
        }
        startTime.setDate(1);
        startTime.setHours(0);
        startTime.setMinutes(0);
        startTime.setSeconds(0);
        startTime.setMilliseconds(0);
        let endTime = new Date();
        endTime.setMonth(endTime.getMonth() + 1)
        endTime.setDate(1);
        endTime.setHours(0);
        endTime.setMinutes(0);
        endTime.setSeconds(0);
        endTime.setMilliseconds(0);
        endTime.setTime(endTime.getTime() - 1);
        return [startTime, endTime]
    }

    // 返回日期时间选择快捷选项
    // 'hours': 只返回小时&今天选项
    // 'day': 只返回今天&N天前选项
    // default: 返回完整的快捷选项
    pickerOptions(type) {
        const _this = this;
        let pickers = [{
            text: '最近一小时',
            onClick(picker) {
                picker.$emit('pick', _this.returnHoursBefore(1));
            }
        }, {
            text: '最近两小时',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnHoursBefore(2));
            }
        }, {
            text: '最近三小时',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnHoursBefore(3));
            }
        }, {
            text: '最近六小时',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnHoursBefore(6));
            }
        }, {
            text: '今天',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnDaysBefore(0));
            }
        }, {
            text: '最近三天',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnDaysBefore(2));
            }
        }, {
            text: '最近五天',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnDaysBefore(4));
            }
        }, {
            text: '最近七天',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnDaysBefore(6));
            }
        }, {
            text: '本月',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnMonthsBefore(0));
            }
        }, {
            text: '最近三个月',
            onClick: function onClick(picker) {
                picker.$emit('pick', _this.returnMonthsBefore(2));
            }
        }]
        switch(type) {
            case 'hours':
                pickers = pickers.splice(0, 5)
            break;
            case 'days':
                pickers = pickers.splice(4)
            break;
            default:

            break;
        }
        return {
            shortcuts: pickers
        }
    }

    // 手机号验证
    isPoneAvailable($poneInput) {
        const telReg=/^[1][1-9][0-9]{9}$/;
        if (!telReg.test($poneInput)) {
            return false;
        } else {
            return true;
        }
    }

    checkTelephone(global_num ,tel) {
        let phoneReg = "";
        if (global_num == "+86") {
            phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; // 验证电话号码正则
        } else {
            phoneReg = /^([0-9]+|0)$/; //手机号必须为数字
        }
        if (!phoneReg.test(tel)) {
            return false;
        }
        return true;
    }

    // 极验初始化
    getGeetestInfo() {
        return axios({
            url: '/v2/passport/gt/init',
            method: 'get',
            params: {}
        })
    }

    // 获取区号
    getCountrySms() {
        return axios({
            method: 'get',
            url: '/v1/phone/sms_locations',
            data: {},
            custom: true
        })
    }
    // 埋点
    doSensorsTrack(name, data) {
        let time = ''
        let fn = () => {
            if (!window.sensors || !window.sensors.track) {// 如果没有这个方法就每10秒调用一次
                clearTimeout(time)
                time = window.setTimeout(fn, 10)
            } else {
                window.sensors.track(name, data)
            }
        }
        time = window.setTimeout(fn, 10)
    }
    /**
     * @name 将时间戳转换成日期格式(年-月-日 23:59:59)
     * @param type {展示类型 'date': 年月日 ｜ 'time': 时分秒 ｜ 'dateTime': 年月日时分秒}
     * @param constructor {连字符 默认：'-' ｜ 年月日：'text'}
     */
    timestampToTime(timestamp, type, constructor) {
        var date = new Date(timestamp),//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        Y = date.getFullYear(),
        M = ( date.getMonth() + 1 < 10 ? '0' + ( date.getMonth() + 1 ) : date.getMonth() ),
        D = ( date.getDate() + 1 < 10 ? '0' + ( date.getDate() + 1 ) : date.getDate() ),
        h = ( date.getHours() < 10 ? '0' + date.getHours() : date.getHours() ) + ':',
        m = ( date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() ) + ':',
        s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        switch(type) {
            case 'date':
                if (constructor === '-') {
                    return Y + '-' + M + '-' + D;
                } else if (constructor === 'text') {
                    return Y + '年' + M + '月' + D + '日';
                } else {}
                break;
            case 'time':
                return h + m + s;
                break;
            case 'dateTime':
                if (constructor === '-') {
                    return Y + '-' + M + '-' + D + ' ' + h + m + s;
                } else if (constructor === 'text') {
                    return Y + '年' + M + '月' + D + '日' + ' ' + h + m + s;
                } else {}
                break;
            default:
                return Y + '年' + M + '月' + D + '日' + ' ' + h + m + s;
        }
    }
}

export default new Base();
